import React from 'react'
import JustoLogo from '@components/JustoLogo'
import Button, {ButtonProps} from '@components/V3/Button'
import {useLoginViaAuthWindow} from '@helpers/auth/loginViaAuth'
import useIsDarkMode from '@hooks/useIsDarkMode'
import {useTranslation} from 'next-i18next'

export default function LoginButton({
  invertColor = false,
  passProps,
  actionLocation = ''
}: {
  invertColor?: boolean
  passProps?: Partial<ButtonProps>
  actionLocation?: string
}) {
  const darkMode = useIsDarkMode()
  const login = useLoginViaAuthWindow(actionLocation)
  const {t} = useTranslation('website', {keyPrefix: 'layout.footer'})

  return (
    <Button
      onClick={login}
      contrast={!invertColor}
      full
      big
      {...passProps}
      icon={() => (
        <JustoLogo
          forceColor={darkMode || invertColor ? 'black' : 'white'}
          noText
          className="mr-2"
        />
      )}>
      {t('labelSignIn')}
    </Button>
  )
}
